<template>
  <base-page
    v-model:entity="entity"
    v-bind:schemaName="'order'"
    v-bind:isHideRemove="true"
    v-bind:isLoading="isLookupLoading"
  >
    <template v-slot:panel-group="{ entity, save }">
      <order-generate-invoice-button
        :entity="entity"
        :statusIds="[OrderStatus.TailoringReadyForShipment]"
        :minimum-pre-payment-amount="minimumPrePaymentAmount"
        @update="
          (value) => {
            (entity.ttn = value),
              (entity.statusId = OrderStatus.Sended);
          }
        "
      />
      <button
        v-if="entity.statusId === OrderStatus.New"
        type="submit"
        v-on:click.prevent="markStatus(entity, save, OrderStatus.TailoringConfirmed)"
        class="btn btn-sm btn-outline-success"
      >
        Підтвердити
      </button>
      <button
        v-if="entity.statusId === OrderStatus.TailoringConfirmed"
        type="submit"
        v-on:click.prevent="confirmInProduction(entity, save)"
        class="btn btn-sm btn-outline-primary"
      >
        У виробництво
      </button>
      <button
        v-if="entity.statusId === OrderStatus.TailoringInProduction"
        type="submit"
        v-on:click.prevent="handleReadyForShipment(entity, save)"
        class="btn btn-sm btn-outline-info"
      >
        Готово до відправки
      </button>
      <button
        v-if="entity.statusId === OrderStatus.TailoringReadyForShipment"
        type="submit"
        v-on:click.prevent="confirmSend(entity, save)"
        class="btn btn-sm btn-outline-success"
      >
        Відправити
      </button>
      <button
        v-if="entity.statusId === OrderStatus.Sended"
        type="submit"
        v-on:click.prevent="refund(entity)"
        class="btn btn-sm btn-outline-warning"
      >
        Повернення
      </button>
      <button
        v-if="entity.statusId === OrderStatus.Sended"
        type="submit"
        v-on:click.prevent="markStatus(entity, save, OrderStatus.Closed)"
        class="btn btn-sm btn-outline-success"
      >
        Закрити
      </button>
      <button
        v-if="!terminalStatuses.includes(entity.statusId)"
        type="submit"
        v-on:click.prevent="markStatus(entity, save, OrderStatus.Cancel)"
        class="btn btn-sm btn-outline-danger"
      >
        Скасувати
      </button>
    </template>
    <template v-slot:toolbar-end="{ entity }">
      <div
        v-if="shouldShowLowPrePaymentWarning(entity)"
        class="tailoring-prepayment-warning"
      >
        Мінімальна передплата замала: потрібно {{ minimumPrePaymentAmount }} грн,
        внесено {{ Number(entity.paymentAmount || 0) }} грн.
      </div>
    </template>
    <template v-slot:panel-left="{ entity }">
      <div class="order-page-compact-side">
        <div class="mb-3 text-left">
          <label class="form-label">Номер</label>
          <input
            :disabled="true"
            type="text"
            class="form-control"
            v-model="entity.number"
          />
        </div>
        <div class="mb-3 text-left">
          <label class="form-label">ТТН</label>
          <input
            :disabled="!isEnabeled(entity)"
            type="text"
            class="form-control"
            v-model="entity.ttn"
          />
        </div>
        <div class="mb-3 text-left">
          <label class="form-label">Статус</label>
          <select
            :disabled="true"
            class="form-control"
            v-model="entity.statusId"
            required
          >
            <option
              v-for="option in tailoringStatuses"
              v-bind:key="option.id"
              :value="option.id"
            >
              {{ option.name }}
            </option>
          </select>
        </div>
        <div class="mb-3 text-left">
          <label class="form-label">{{
            $filters.localize("OrderPage.fields.kind") }}</label>
          <select
            :disabled="!isEnabeled(entity)"
            class="form-control"
            v-model="entity.kind"
            required
          >
            <option value="Wholesale">{{
              $filters.localize("OrderPage.kind.wholesale") }}</option>
            <option value="Retail">{{ $filters.localize("OrderPage.kind.retail")
            }}</option>
          </select>
        </div>
        <div class="mb-3 text-left">
          <label class="form-label">{{
            $filters.localize("OrderPage.fields.fulfillmentKind") }}</label>
          <select
            disabled
            class="form-control"
            v-model="entity.fulfillmentKind"
            required
          >
            <option value="Tailoring">{{
              $filters.localize("OrderPage.fulfillmentKind.tailoring") }}
            </option>
          </select>
        </div>
        <div class="mb-3 text-left">
          <label class="form-label">Статус оплати</label>
          <select
            :disabled="entity.paymentStatusId == '2bf61851-347c-4d0d-a62e-d488dce9c0da' ||
              entity.paymentStatusId == '3bf61851-347c-4d0d-a62e-d488dce9c0da'
              "
            class="form-control"
            v-model="entity.paymentStatusId"
          >
            <option
              v-for="option in paymentStatuses"
              v-bind:key="option.id"
              :value="option.id"
            >
              {{ option.name }}
            </option>
          </select>
        </div>
        <div class="mb-3 text-left">
          <label class="form-label">Клієнт</label>
          <paginated-select
            v-model="entity.client"
            table="contact"
            label-field="fullName"
            value-field="fullName"
            class="order-page-select-no-clear"
            :disabled="!isEnabeled(entity)"
            :clearable="false"
            :allow-custom="true"
            required
          />
        </div>
        <div class="mb-3 text-left">
          <label class="form-label">Відповідальний</label>
          <paginated-select
            v-model="entity.contactId"
            table="contact"
            label-field="fullName"
            class="order-page-select-no-clear"
            :disabled="!isEnabeled(entity)"
            :clearable="false"
          />
        </div>
        <div class="mb-3 text-left">
          <label class="form-label">Рахунок оплати (ФОП)</label>
          <select
            :disabled="paymentDetails.length === 0 || !isEnabeled(entity)"
            class="form-control"
            v-model="entity.paymentDetailId"
          >
            <option selected></option>
            <option
              v-for="option in paymentDetails"
              v-bind:key="option.id"
              :value="option.id"
            >
              {{ option.name }}
            </option>
          </select>
        </div>
        <div class="mb-3 text-left">
          <label class="form-label">Оплатив</label>
          <input
            :disabled="!isEnabeled(entity)"
            type="text"
            class="form-control"
            v-model="entity.paymentPayer"
          />
        </div>
        <div class="mb-3 text-left">
          <label class="form-label">Час оплати</label>
          <input
            :disabled="!isEnabeled(entity)"
            type="datetime-local"
            min="0"
            class="form-control"
            v-model="entity.paymentTime"
          />
        </div>
        <div class="mb-3 text-left">
          <label class="form-label">Сума передплати</label>
          <input
            :disabled="!isEnabeled(entity)"
            type="number"
            min="0"
            class="form-control"
            v-model="entity.paymentAmount"
          />
          <small
            v-if="shouldShowMinimumPrePayment(entity)"
            class="form-text text-muted"
          >
            Мінімальна передплата: {{ minimumPrePaymentAmount }}
          </small>
        </div>
        <div class="mb-3 text-left">
          <label class="form-label">Ціна</label>
          <input
            disabled
            type="number"
            min="0"
            class="form-control"
            v-model="entity.totalCost"
          />
        </div>
        <div class="mb-3 text-left">
          <label class="form-label">Вартість закупки</label>
          <input
            disabled
            type="number"
            min="0"
            class="form-control"
            v-model="entity.totalPurchaseCosts"
          />
        </div>
        <div
          v-if="isRetail"
          class="mb-3 text-left"
        >
          <label class="form-label">{{
            $filters.localize("OrderPage.fields.source") }}</label>
          <select
            :disabled="!isEnabeled(entity)"
            class="form-control"
            v-model="entity.source"
          >
            <option
              v-for="option in orderSourceOptions"
              :key="option.id"
              :value="option.id"
            >
              {{ option.name }}
            </option>
          </select>
        </div>
        <div class="mb-3 text-left">
          <label class="form-label">Оплата балансом</label>
          <input
            disabled
            type="number"
            min="0"
            class="form-control"
            v-model="entity.bonusPaidAmount"
          />
        </div>
      </div>
    </template>

    <template v-slot:header="{ entity }">
      <div class="order-page-compact-header">
        <div class="order-page-compact-header__grid">
          <div class="order-page-compact-header__field text-left">
            <label class="form-label">До сплати (накладений платіж)</label>
            <input
              :disabled="!isEnabeled(entity)"
              type="number"
              :min="entity.totalCost - entity.paymentAmount - entity.bonusPaidAmount"
              class="form-control"
              v-model="entity.cashPaidAmount"
            />
          </div>
          <div class="order-page-compact-header__field text-left">
            <label class="form-label">Маржа Дропа</label>
            <div class="form-control">
              {{
                Number(entity.cashPaidAmount) +
                Number(entity.bonusPaidAmount) +
                Number(entity.paymentAmount) -
                Number(entity.totalCost)
              }}
            </div>
          </div>
          <div class="order-page-compact-header__field text-left">
            <label class="form-label">Прибуток</label>
            <div class="form-control">
              {{
                Number(entity.cashPaidAmount) +
                Number(entity.bonusPaidAmount) +
                Number(entity.paymentAmount) -
                Number(entity.totalPurchaseCosts) -
                (Number(entity.cashPaidAmount) +
                  Number(entity.bonusPaidAmount) +
                  Number(entity.paymentAmount) -
                  Number(entity.totalCost)) -
                Number(entity.giftAmount)
              }}
            </div>
          </div>
          <div class="order-page-compact-header__field text-left">
            <label class="form-label">Тип оплати</label>
            <select
              :disabled="deliveryTypes.length === 0 || !isEnabeled(entity)"
              class="form-control"
              v-model="entity.deliveryTypeId"
              :required="requiresDeliveryFields(entity.statusId)"
            >
              <option
                v-for="option in deliveryTypes"
                v-bind:key="option.id"
                :value="option.id"
              >
                {{ option.name }}
              </option>
            </select>
          </div>
          <div class="order-page-compact-header__field text-left">
            <label class="form-label">Служба доставки</label>
            <select
              :disabled="deliveryServices.length === 0 || !isEnabeled(entity)"
              class="form-control"
              v-model="entity.deliveryServiceId"
              :required="requiresDeliveryFields(entity.statusId)"
            >
              <option
                v-for="option in deliveryServices"
                v-bind:key="option.id"
                :value="option.id"
              >
                {{ option.name }}
              </option>
            </select>
          </div>
          <div class="order-page-compact-header__field text-left">
            <label class="form-label">Місто</label>
            <input
              :disabled="!isEnabeled(entity)"
              type="text"
              class="form-control"
              v-model="entity.city"
              v-if="
                entity.deliveryServiceId !=
                '1bf61851-347c-4d0d-a62e-d488dce9c0da'
              "
              :required="requiresDeliveryFields(entity.statusId)"
            />
            <selector-city
              v-else
              :disabled="!isEnabeled(entity)"
              class="order-page-select-no-clear"
              :entity="entity"
              @update="
                (value) => {
                  entity.city = value?.code || '';
                  entity.cityName = value?.label || '';
                  entity.address = '';
                }
              "
              :required="requiresDeliveryFields(entity.statusId)"
            />
          </div>
          <div class="order-page-compact-header__field text-left">
            <label class="form-label">Адреса</label>
            <input
              :disabled="!isEnabeled(entity)"
              type="text"
              class="form-control"
              v-if="
                entity.deliveryServiceId !=
                '1bf61851-347c-4d0d-a62e-d488dce9c0da'
              "
              v-model="entity.address"
              :required="requiresDeliveryFields(entity.statusId)"
            />
            <selector-address
              v-else
              :disabled="!isEnabeled(entity)"
              class="order-page-select-no-clear"
              :entity="entity"
              @update="
                (value) => {
                  entity.address = value;
                }
              "
              :disable="!entity.city || entity.city.length === 0"
              :required="requiresDeliveryFields(entity.statusId)"
            />
          </div>
          <div class="order-page-compact-header__field text-left">
            <label class="form-label">Отримувач</label>
            <input
              :disabled="!isEnabeled(entity)"
              type="text"
              class="form-control"
              v-model="entity.recipient"
              :required="requiresDeliveryFields(entity.statusId)"
            />
          </div>
          <div class="order-page-compact-header__field text-left">
            <label class="form-label">Мобільний телефон</label>
            <input
              pattern="^\+[0-9]{12}$"
              :disabled="!isEnabeled(entity)"
              type="tel"
              placeholder="+380111111111"
              class="form-control"
              v-model="entity.recipientPhone"
              @input="entity.recipientPhone = normalizePhone(entity.recipientPhone)"
              :required="requiresDeliveryFields(entity.statusId)"
            />
          </div>
          <div
            class="order-page-compact-header__field order-page-compact-header__comment text-left"
          >
            <label class="form-label">Коментар</label>
            <textarea
              class="form-control"
              v-model="entity.comment"
              rows="8"
            ></textarea>
          </div>
        </div>
      </div>
    </template>
    <template v-slot:body="{ entity, action, onLoadData, save }">
      <order-product-detail
        v-if="entity.id"
        v-on:on-parrent-load="onLoadData"
        v-on:main-save="save"
        v-bind:rootId="entity.id"
        v-bind:orderKind="entity.kind"
        v-bind:orderFulfillmentKind="entity.fulfillmentKind"
        v-bind:tailoringOnly="true"
        v-bind:contactId="entity.contactId"
        v-bind:rootColumn="'ActivityId'"
        v-bind:enabled="action == 'update'"
        v-bind:canModify="canModifyOrderDetails(entity)"
        class="mb-3"
      />

      <order-promotion-detail
        v-if="entity.id"
        v-bind:rootId="entity.id"
        v-on:on-parrent-load="onLoadData"
        v-on:main-save="save"
        v-bind:orderKind="entity.kind"
        v-bind:rootColumn="'OrderId'"
        v-bind:canModify="canModifyOrderDetails(entity)"
        class="mb-3"
      />

      <transactions-detail
        v-if="entity.id"
        v-bind:rootId="entity.id"
        v-on:main-save="save"
        v-bind:contactId="entity.contactId"
        v-bind:rootColumn="'ActivityId'"
        v-bind:enabled="action == 'update'"
        class="mb-3"
      />
    </template>
  </base-page>
  <low-pre-payment-confirm-modal
    :is-open="isReadyForShipmentConfirmOpen"
    :loading="isReadyForShipmentConfirming"
    :minimum-pre-payment-amount="minimumPrePaymentAmount"
    :paid-amount="readyForShipmentPaidAmount"
    subject="відшиву"
    confirm-label="Все одно підтвердити"
    loading-label="Зберігається..."
    @close="closeReadyForShipmentConfirmation"
    @confirm="confirmReadyForShipment"
  />
</template>

<script>
import TransactionsDetail from "@/views/details/transactions/TransactionsDetail.vue";
import OrderProductDetail from "@/views/details/products/OrderProductDetail.vue";
import OrderPromotionDetail from "@/views/details/promotions/OrderPromotionDetail.vue";
import BasePage from "@/components/Sections/BasePage.vue";
import SelectorCity from "@/components/Selectors/SelectorCity.vue";
import SelectorAddress from "@/components/Selectors/SelectorAddress.vue";
import PaginatedSelect from "@/components/Selectors/PaginatedSelect.vue";
import OrderGenerateInvoiceButton from "@/views/orders/components/OrderGenerateInvoiceButton.vue";
import LowPrePaymentConfirmModal from "@/views/orders/components/LowPrePaymentConfirmModal.vue";
import { OrderStatus } from "@/utilities/OrderStatus";
import { getOrderSourceOptions } from "@/utilities/OrderSource";
import { localizeDeliveryServices } from "@/utilities/DeliveryService";

export default {
  name: "TailoringOrderPage",
  components: {
    BasePage,
    TransactionsDetail,
    OrderProductDetail,
    OrderPromotionDetail,
    SelectorCity,
    SelectorAddress,
    PaginatedSelect,
    OrderGenerateInvoiceButton,
    LowPrePaymentConfirmModal,
  },
  data() {
    return {
      OrderStatus,
      entity: {},
      statuses: [],
      deliveryTypes: [],
      deliveryServices: [],
      isLookupLoading: false,
      paymentStatuses: [],
      paymentDetails: [],
      productsCount: 0,
      defaultPrePayment: 300,
      defaultPrePaymentStep: 100,
      actionInProcess: false,
      isReadyForShipmentConfirmOpen: false,
      isReadyForShipmentConfirming: false,
      readyForShipmentConfirmation: null,
    };
  },
  watch: {
    "entity.paymentAmount": {
      handler(newValue, oldValue) {
        const delta = newValue - oldValue;
        if (delta) {
          this.entity.cashPaidAmount -= delta;
        }
      },
      deep: true,
      immediate: true,
    },
    "entity.id": {
      async handler(value) {
        if (!value) {
          this.productsCount = 0;
          return;
        }

        await this.loadProductsCount(value);
      },
      immediate: true,
    },
  },
  computed: {
    isRetail() {
      return this.entity?.kind === "Retail";
    },
    terminalStatuses() {
      return [OrderStatus.Cancel, OrderStatus.Closed, OrderStatus.Refund];
    },
    tailoringStatuses() {
      const allowedStatuses = [
        OrderStatus.New,
        OrderStatus.TailoringConfirmed,
        OrderStatus.TailoringInProduction,
        OrderStatus.TailoringReadyForShipment,
        OrderStatus.Sended,
        OrderStatus.Closed,
        OrderStatus.Cancel,
        OrderStatus.Refund,
      ];

      return this.statuses.filter((x) => allowedStatuses.includes(x.id));
    },
    prePaymentStepValue() {
      return Number(this.defaultPrePaymentStep) || 0;
    },
    minimumPrePaymentAmount() {
      const bonusPaidAmount = Number(this.entity?.bonusPaidAmount || 0);
      const totalCost = Number(this.entity?.totalCost || 0);
      const giftAmount = Number(this.entity?.giftAmount || 0);
      const amountDue = Math.max(0, totalCost - bonusPaidAmount);

      if (
        this.entity?.deliveryTypeId === "1bf61851-347c-4d0d-a62e-d488dce9c0da"
      ) {
        return amountDue;
      }

      const minimum =
        (Number(this.defaultPrePayment) || 0) +
        Math.max(0, this.productsCount - 1) * this.prePaymentStepValue +
        giftAmount -
        bonusPaidAmount;

      return Math.max(0, Math.min(amountDue, minimum));
    },
    orderSourceOptions() {
      return getOrderSourceOptions(this.$filters.localize, { includeEmpty: true });
    },
    readyForShipmentPaidAmount() {
      return Number(
        this.readyForShipmentConfirmation?.entity?.paymentAmount ??
        this.entity?.paymentAmount ??
        0
      );
    },
  },
  methods: {
    normalizePhone(value) {
      const digits = String(value ?? "").replace(/\D/g, "");

      if (!digits) {
        return "";
      }

      if (digits.startsWith("380")) {
        return `+${digits.slice(0, 12)}`;
      }

      if (digits.startsWith("0")) {
        return `+38${digits.slice(0, 10)}`;
      }

      return `+${digits.slice(0, 12)}`;
    },
    isEnabeled(entity) {
      return !this.terminalStatuses.includes(entity?.statusId);
    },
    canModifyOrderDetails(entity) {
      return this.isEnabeled(entity);
    },
    async markStatus(entity, save, statusId) {
      entity.statusId = statusId;
      await save();
    },
    hasMinimumPrePaymentMismatch(entity) {
      return (
        this.shouldShowMinimumPrePayment(entity) &&
        Number(entity?.paymentAmount || 0) < this.minimumPrePaymentAmount
      );
    },
    async handleReadyForShipment(entity, save) {
      if (this.hasMinimumPrePaymentMismatch(entity)) {
        this.readyForShipmentConfirmation = { entity, save };
        this.isReadyForShipmentConfirmOpen = true;
        return;
      }

      await this.markStatus(entity, save, OrderStatus.TailoringReadyForShipment);
    },
    closeReadyForShipmentConfirmation() {
      if (this.isReadyForShipmentConfirming) {
        return;
      }

      this.isReadyForShipmentConfirmOpen = false;
      this.readyForShipmentConfirmation = null;
    },
    async confirmReadyForShipment() {
      if (!this.readyForShipmentConfirmation) {
        return;
      }

      try {
        this.isReadyForShipmentConfirming = true;
        await this.markStatus(
          this.readyForShipmentConfirmation.entity,
          this.readyForShipmentConfirmation.save,
          OrderStatus.TailoringReadyForShipment
        );
        this.isReadyForShipmentConfirmOpen = false;
        this.readyForShipmentConfirmation = null;
      } finally {
        this.isReadyForShipmentConfirming = false;
      }
    },
    async refund(entity) {
      if (this.actionInProcess) {
        this.$toast.warning("Запит в обробці, очікуйте на відповідь...");
        return;
      }

      try {
        this.actionInProcess = true;
        const response = await this.$store.dispatch("post", {
          table: "Order",
          method: "refund",
          body: { Id: entity.id },
        });
        entity.statusId = response.data.data.statusId;
      } catch (error) {
        this.$toast.error(error.response.data.message);
      } finally {
        this.actionInProcess = false;
      }
    },
    async confirmInProduction(entity, save) {
      if (!entity.deliveryTypeId) {
        this.$toast.warning("Вкажіть тип оплати перед передачею у виробництво.");
        return;
      }

      await this.markStatus(entity, save, OrderStatus.TailoringInProduction);
    },
    requiresDeliveryFields(statusId) {
      return [
        OrderStatus.TailoringReadyForShipment,
        OrderStatus.Sended,
        OrderStatus.Closed,
        OrderStatus.Refund,
      ].includes(statusId);
    },
    shouldShowMinimumPrePayment(entity) {
      if (!entity?.deliveryTypeId) {
        return false;
      }

      return [
        OrderStatus.TailoringConfirmed,
        OrderStatus.TailoringInProduction,
        OrderStatus.TailoringReadyForShipment,
        OrderStatus.Sended,
        OrderStatus.Closed,
        OrderStatus.Refund,
      ].includes(entity.statusId);
    },
    shouldShowLowPrePaymentWarning(entity) {
      return (
        this.hasMinimumPrePaymentMismatch(entity)
      );
    },
    async confirmSend(entity, save) {
      if (
        !entity.ttn ||
        !entity.city ||
        !entity.address ||
        !entity.deliveryTypeId ||
        !entity.deliveryServiceId ||
        !entity.recipient ||
        !entity.recipientPhone
      ) {
        this.$toast.warning("Заповніть всі обов'язкові поля для відправки.");
        return;
      }

      await this.markStatus(entity, save, OrderStatus.Sended);
    },
    async loadLookups() {
      this.isLookupLoading = true;
      const load = async (table) => {
        const result = await this.$store.dispatch("section", { table });
        return result.data.data;
      };

      try {
        const [
          statuses,
          deliveryTypes,
          deliveryServices,
          paymentStatuses,
          paymentDetails,
          defaultPrePayment,
          defaultPrePaymentStep,
        ] = await Promise.all([
          load("orderStatus"),
          load("deliveryType"),
          load("deliveryService"),
          load("paymentStatus"),
          load("paymentdetail"),
          this.loadSettingByCode("DefaultTailoringPrePayment", 300),
          this.loadSettingByCode("DefaultTailoringPrePaymentStep", 100),
        ]);

        this.statuses = statuses;
        this.deliveryTypes = deliveryTypes;
        this.deliveryServices = localizeDeliveryServices(deliveryServices);
        this.paymentStatuses = paymentStatuses;
        this.paymentDetails = paymentDetails;
        this.defaultPrePayment = defaultPrePayment;
        this.defaultPrePaymentStep = defaultPrePaymentStep;
      } finally {
        this.isLookupLoading = false;
      }
    },
    async loadSettingByCode(code, fallback) {
      const response = await this.$store.dispatch("getFilter", {
        table: "SystemSetting",
        body: { id: code, rootColumn: "Code" },
      });

      return Number(response.data.data?.[0]?.value ?? fallback) || fallback;
    },
    async loadProductsCount(orderId) {
      const response = await this.$store.dispatch("getFilter", {
        table: "OrderProduct",
        body: { id: orderId, rootColumn: "ActivityId" },
      });

      this.productsCount = response.data.data.reduce(
        (sum, item) => sum + Number(item.quantity || 0),
        0
      );
    },
  },
  mounted() {
    this.loadLookups();
  },
};
</script>

<style scoped>
.order-page-compact-header,
.order-page-compact-side {
  --order-control-height: 32px;
  --order-control-font-size: 14px;
  --order-control-line-height: 19px;
  --order-label-height: 14px;
  --order-label-gap: 3px;
  --order-field-gap: 12px;
  --order-field-height: calc(
    var(--order-label-height) + var(--order-label-gap) + var(--order-control-height)
  );

  padding: 4px 6px 0;
}

.order-page-compact-header__grid {
  display: grid;
  grid-template-columns:
    minmax(260px, 0.9fr)
    minmax(126px, 0.45fr)
    minmax(126px, 0.45fr);
  grid-template-rows: repeat(4, var(--order-field-height)) auto;
  grid-auto-rows: var(--order-field-height);
  gap: var(--order-field-gap);
  width: 100%;
  align-items: start;
}

.order-page-compact-header__field {
  display: flex;
  flex-direction: column;
  min-width: 0;
  height: var(--order-field-height);
}

.order-page-compact-header__field:nth-child(1) {
  grid-column: 1;
  grid-row: 1;
}

.order-page-compact-header__field:nth-child(2) {
  grid-column: 2;
  grid-row: 1;
}

.order-page-compact-header__field:nth-child(3) {
  grid-column: 3;
  grid-row: 1;
}

.order-page-compact-header__field:nth-child(4) {
  grid-column: 1;
  grid-row: 2;
}

.order-page-compact-header__field:nth-child(5) {
  grid-column: 2 / 4;
  grid-row: 2;
}

.order-page-compact-header__field:nth-child(6) {
  grid-column: 1;
  grid-row: 3;
}

.order-page-compact-header__field:nth-child(7) {
  grid-column: 2 / 4;
  grid-row: 3;
}

.order-page-compact-header__field:nth-child(8) {
  grid-column: 1;
  grid-row: 4;
}

.order-page-compact-header__field:nth-child(9) {
  grid-column: 2 / 4;
  grid-row: 4;
}

.order-page-compact-side>.mb-3 {
  min-height: var(--order-field-height);
  margin-bottom: var(--order-field-gap) !important;
}

.order-page-compact-header .form-label,
.order-page-compact-side .form-label {
  display: block;
  height: var(--order-label-height);
  margin-bottom: var(--order-label-gap);
  color: #526171;
  font-size: 12px;
  font-weight: 400;
  line-height: var(--order-label-height);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.order-page-compact-header .form-control,
.order-page-compact-side .form-control {
  display: block;
  width: 100%;
  min-height: var(--order-control-height);
  height: var(--order-control-height);
  max-height: var(--order-control-height);
  box-sizing: border-box;
  padding: 6px 8px;
  font-size: var(--order-control-font-size);
  line-height: var(--order-control-line-height);
}

.order-page-compact-header select.form-control,
.order-page-compact-side select.form-control {
  padding-right: 1.9rem;
}

.order-page-compact-header__field>.form-control,
.order-page-compact-header__field>.v-select {
  flex: 0 0 auto;
}

.order-page-compact-header :deep(.v-select),
.order-page-compact-side :deep(.v-select) {
  display: flex;
  width: 100%;
  height: var(--order-control-height);
  font-size: var(--order-control-font-size);
  text-align: left;
}

.order-page-compact-header :deep(.vs__dropdown-toggle),
.order-page-compact-side :deep(.vs__dropdown-toggle) {
  flex: 1;
  min-height: var(--order-control-height);
  height: var(--order-control-height);
  max-height: var(--order-control-height);
  box-sizing: border-box;
  padding: 0 4px;
  border-color: #ced4da;
  border-radius: 4px;
}

.order-page-compact-header :deep(.order-page-select-no-clear .vs__dropdown-toggle) {
  border-color: #ced4da;
  border-radius: 4px;
  background: #ffffff;
  padding: 0 4px 0 8px;
}

.order-page-compact-header :deep(.vs__selected-options),
.order-page-compact-side :deep(.vs__selected-options) {
  min-width: 0;
  align-items: center;
  padding: 0 2px;
}

.order-page-compact-header :deep(.order-page-select-no-clear .vs__selected-options) {
  flex-wrap: nowrap;
  overflow: hidden;
  padding: 0;
}

.order-page-compact-header :deep(.order-page-select-no-clear .vs__selected) {
  margin: 0;
  padding: 0;
}

.order-page-compact-header :deep(.vs__selected),
.order-page-compact-side :deep(.vs__selected) {
  min-width: 0;
  color: #495057;
  font-size: var(--order-control-font-size);
  line-height: var(--order-control-line-height);
  margin: 0 2px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.order-page-compact-header :deep(.order-page-select-no-clear .vs__search),
.order-page-compact-header :deep(.order-page-select-no-clear .vs__search:focus) {
  margin: 0;
  padding: 0;
  color: #495057;
  font-size: var(--order-control-font-size);
  line-height: var(--order-control-line-height);
}

.order-page-compact-header :deep(.vs__actions),
.order-page-compact-side :deep(.vs__actions) {
  flex: 0 0 auto;
  padding: 0 4px 0 2px;
}

.order-page-compact-header :deep(.order-page-select-no-clear .vs__actions) {
  padding: 0 4px 0 2px;
}

.order-page-compact-header :deep(.order-page-select-no-clear .vs__clear) {
  display: none;
}

.order-page-compact-side .form-text {
  margin-top: 3px;
  font-size: 12px;
  line-height: 1.2;
}

.tailoring-prepayment-warning {
  margin-bottom: 0;
  padding: 10px 12px;
  border: 1px solid #f2d46b;
  border-radius: 8px;
  color: #513f00;
  background: #fff7d6;
  font-size: 0.95rem;
  line-height: 1.25;
  text-align: left;
}

.order-page-compact-header textarea.form-control {
  width: 100%;
  height: auto;
  max-height: none;
  min-height: var(--order-control-height);
  resize: vertical;
}

.order-page-compact-header__comment {
  align-self: stretch;
  display: flex;
  flex-direction: column;
  grid-column: 1 / -1;
  grid-row: 5;
  height: auto;
}

.order-page-compact-header__comment textarea.form-control {
  flex: 0 0 auto;
  height: auto;
  max-height: none;
  min-height: 96px;
}

@media (max-width: 1199.98px) {
  .order-page-compact-header__grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    grid-template-rows: none;
    grid-auto-rows: auto;
  }

  .order-page-compact-header__field:nth-child(n) {
    grid-column: auto;
    grid-row: auto;
  }

  .order-page-compact-header__comment {
    height: auto;
  }

  .order-page-compact-header__comment textarea.form-control {
    height: auto;
    min-height: 120px;
  }
}

@media (max-width: 767.98px) {
  .order-page-compact-header,
  .order-page-compact-side {
    --order-control-height: 38px;
    --order-control-font-size: 16px;
    --order-control-line-height: 22px;
    --order-label-height: 15px;
    padding-left: 10px;
    padding-right: 10px;
  }

  .order-page-compact-header__grid {
    grid-template-columns: 1fr;
    grid-auto-rows: auto;
  }

  .order-page-compact-header__field {
    height: auto;
  }
}
</style>
